module.exports = __webpack_public_path__ + "arrow.9bec032f476bd71e6015.png";


//////////////////
// WEBPACK FOOTER
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/assets/img/arrow.png
// module id = ../../../../../src/assets/img/arrow.png
// module chunks = styles